exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@font-face {\n  font-family: 'cat';\n  src: url(\"/assets/fonts/cat.eot?vcfb5d\");\n  src: url(\"/assets/fonts/cat.eot?vcfb5d#iefix\") format(\"embedded-opentype\"), url(\"/assets/fonts/cat.ttf?vcfb5d\") format(\"truetype\"), url(\"/assets/fonts/cat.woff?vcfb5d\") format(\"woff\"), url(\"/assets/fonts/cat.svg?vcfb5d#cat\") format(\"svg\");\n  font-weight: normal;\n  font-style: normal; }\n\n:host {\n  width: 100%;\n  height: 100%;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column; }\n  :host .modal-body {\n    -webkit-box-flex: 1;\n        -ms-flex: 1;\n            flex: 1; }\n  :host .controls {\n    border-top-style: dashed;\n    border-top-color: #ddd;\n    border-top-width: 1px;\n    padding-top: 0.5rem;\n    padding-bottom: 0.5rem;\n    text-align: right; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_release@2/app/Resources/Public/src/app/modules/models/network-interfaces/components/network-if-list/network-if-list.component.scss
// module id = ../../../../../src/app/modules/models/network-interfaces/components/network-if-list/network-if-list.component.scss
// module chunks = main